import {GroupedData} from "../group";
import ModelEntity from "../../model2/model-entity";
import GroupBy from "../../gd/manager/group-by/group-by-model";

const debug = false
// const debug = "groupByOperator"

export default function groupByOperator(models:ModelEntity[], groupBy:GroupBy) {
    debug && console.log(debug, 'process() total models=', _.size(models), "groupBy=", groupBy)

    if (!groupBy.field) {
        throw Error("#kdjdsj304383jd no field")
    }

    const fieldId = groupBy.field.fieldId

    const result:GroupedData = _(models)
        .groupBy((model)=>{
            // @ts-ignore
            const value         = model[fieldId]
            const groupByValue  = groupBy.getValue(value)

            return !_.isNil(groupByValue) ? groupByValue : null;
        })
        .toPairs()
        .map((group)=> {

            let value : any  = group[0]
            // patch - important here !
            if (value === 'null') value = null

            return {
                value       : value,
                sortValue   : groupBy.getSortValue(value),
                field       : groupBy.field,
                label       : groupBy.getLabel(value),
                items       : group[1]
            }
        })
        .orderBy((group)=>{
            return group.sortValue
        }, groupBy.sortDirection as any)
        .value() as GroupedData;

    debug && console.log(debug, 'process result', result)

    return result
}

